import { ICON_TYPES } from '../constants';

export const TwitterIcon = (): JSX.Element => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9904_18312)">
        <path
          d="M8.14575 7.61914L14.8028 16.3229H15.8228L9.2415 7.61914H8.14575Z"
          fill="white"
        />
        <path
          d="M3 3V21H21V3H3ZM14.2972 17.424L11.3947 13.6327L8.07825 17.424H6.23475L10.5345 12.5085L6 6.576H9.7965L12.417 10.0417L15.4493 6.576H17.2905L13.2697 11.1705L18 17.4233L14.2972 17.424Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_9904_18312">
          <rect x="3" y="3" width="18" height="18" rx="1.2" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

TwitterIcon.iconType = ICON_TYPES.TWITTER;
